<template>
    <div v-if="this.menu == true" class="md-toolbar-section-end">
        <a
            v-bind:href="'tel:'+getPhoneNumberWithoutSpaces"
            rel="noopener"
            class="main_menu_header_phone desktop-only"
        >
            <img src="/imgs/phone-green.svg" class="footer_phone" /> {{getPhoneNumber}}
        </a>
        <a
            v-bind:href="'tel:'+getPhoneNumberWithoutSpaces"
            rel="noopener"
            class="main_menu_header_phone mobile-only"
        >{{getPhoneNumber}}</a>
        
    </div>
    <div v-else-if="this.menu == false">
        <a v-bind:href="'tel:'+getPhoneNumberWithoutSpaces" rel="noopener">
            <img src="/imgs/phone.svg" class="footer_phone">
                {{getPhoneNumber}}
        </a>
    </div>
</template>

<script>
export default {
    props: {
        menu: Boolean,
    },
    data() {
        return {
            country: null,
        };
    },
    mounted() {
        this.getCountryExtension();
    },
    computed: {
        getPhoneNumber() {
            return this.country ? this.country.phone_number : ''; 
        },
        getPhoneNumberWithoutSpaces() {
            return this.getPhoneNumber.replace(/\s+/g, '');
        },

    },
    methods: {
        getCountryExtension() {
            axios.get(`/api/domain-country/${location.host}`).then(response => {
                this.country = response.data;
            });
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/widgets/GetCountryDomain.vue